// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/Content/ContentTravel.js

import React, { useState, useEffect } from 'react';
import Sidebar from '../../pages/Sidebar';
import Header from '../Header';
import ContentTable from './ContentTable';
import ContentTravelForm from './ContentTravelForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { ProgressSpinner } from 'primereact/progressspinner';
import '../../css/Member.css';
import {
  fetchTravelData,
  handleAddTravel,
  handleEditTravel,
  handleCancelEdit,
  handleSaveTravel,
  handleDelete,
} from '../../utils/ContentTravelHandlers';

const ContentTravel = () => {
  const [travelData, setTravelData] = useState([]);
  const [currentTravel, setCurrentTravel] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [formMode, setFormMode] = useState('add');
  const [searchQuery, setSearchQuery] = useState('');
  const [pageLength, setPageLength] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchTravelData(setTravelData, setTotalCount, setIsLoading, currentPage, pageLength);
  }, [currentPage, pageLength]);

  const handleRefresh = () => {
    fetchTravelData(setTravelData, setTotalCount, setIsLoading, currentPage, pageLength);
  };

  const handlePageLengthChange = (e) => {
    setPageLength(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboard-main">
        <Header
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          placeholderText="Search travel..."
          refreshData={handleRefresh}
          onBack={isFormVisible ? () => handleCancelEdit(setIsFormVisible) : undefined}
        />
        <div className="p-datatable-details">
          <div className="member-table-container">
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <div className="select-container me-md-2">
                <select
                  id="pageLengthSelect"
                  className="form-select"
                  value={pageLength}
                  onChange={handlePageLengthChange}
                >
                  <option value="10">10 Rows</option>
                  <option value="20">20 Rows</option>
                  <option value="50">50 Rows</option>
                </select>
              </div>
              <button
                onClick={() => handleAddTravel(setCurrentTravel, setFormMode, setIsFormVisible)}
                className="btn btn-dark btn-sm"
              >
                <FontAwesomeIcon icon={faPlus} /> Create New Travel
              </button>
            </div>

            {isLoading ? (
              <div className="text-center my-4">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="transparent" animationDuration=".5s" />
              </div>
            ) : isFormVisible ? (
              <ContentTravelForm
                travelData={currentTravel}
                mode={formMode}
                onCancel={() => handleCancelEdit(setIsFormVisible)}
                onSave={(data) =>
                  handleSaveTravel(data, setIsFormVisible, setIsLoading, () =>
                    fetchTravelData(setTravelData, setTotalCount, setIsLoading, currentPage, pageLength)
                  )
                }
              />
            ) : (
              <ContentTable
                travelData={travelData}
                onEditTravel={(travelId) =>
                  handleEditTravel(travelId, travelData, setCurrentTravel, setFormMode, setIsFormVisible)
                }
                onDelete={(selectedTravelIds) =>
                  handleDelete(selectedTravelIds, setIsLoading, () =>
                    fetchTravelData(setTravelData, setTotalCount, setIsLoading, currentPage, pageLength)
                  )
                }
                searchQuery={searchQuery}
                pageLength={pageLength}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalCount={totalCount}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentTravel;